import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_FILE_TYPES_CONFIG, GET_FILE_TYPES_CONFIG_SUCCESS, GET_FILE_TYPES_CONFIG_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getFileTypesConfig({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/getFileTypeConfig`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_FILE_TYPES_CONFIG_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_FILE_TYPES_CONFIG_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_FILE_TYPES_CONFIG_ERROR, payload: error });
  }
}

export function* watchGetFileTypesConfig() {
  yield takeEvery(GET_FILE_TYPES_CONFIG, getFileTypesConfig);
}

function* getFileTypesConfigSaga() {
  yield all([fork(watchGetFileTypesConfig)]);
}

export default getFileTypesConfigSaga;
